(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@nodeject/wbs"), require("cytoscape"));
	else if(typeof define === 'function' && define.amd)
		define("wbs-react", ["react", "@nodeject/wbs", "cytoscape"], factory);
	else if(typeof exports === 'object')
		exports["wbs-react"] = factory(require("react"), require("@nodeject/wbs"), require("cytoscape"));
	else
		root["wbs-react"] = factory(root["React"], root["@nodeject/wbs"], root["cytoscape"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_18__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition